module.exports = __webpack_public_path__ + "img/018-half-moon-1.79e83ffe.svg";